module.exports = "<div ui-view\n  ng-cloak>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/dispatch/templates/index.html
// module id = 1491
// module chunks = 0